/* eslint-disable max-len */

export const LANG_EN = Object.freeze({
    'Ленинградская область': 'The Leningrad region',

    'Русский': 'Русский',
    'English': 'English',
    // -- карта
    'km': 'km',
    'm': 'm',
    // -- инструменты
    'LOCATION': 'Location',
    'DISTANCE': 'Distance',
    'AREA': 'Area',
    'RADIUS': 'Radius',

    'OBJECTS_COUNT': '{{count, number}} object',
    'OBJECTS_COUNT_plural': '{{count, number}} objects',

    'FILES_COUNT': '{{count, number}} file',
    'FILES_COUNT_plural': '{{count, number}} files',

    'LICENSE_AGREEMENT': 'By clicking on this button, you agree to process your personal data according to the <a href="https://map.lenoblinvest.ru/en/terms_of_use/" target="_blank">terms of the user agreement</a> and <a href="https://map.lenoblinvest.ru/en/privacy_policy/" target="_blank">privacy policy</a>.',

    'list': 'List | {{count, number}}',
    'Подбор площадки': 'Site selection',

    'POWER_FILTER_LABEL_DISTANCE': 'Distance',
    'POWER_FILTER_LABEL_FREE_POWER': 'Free power',
    'POWER_FILTER_FREE_BANDWIDTH': 'Free capacity',
    'POWER_FILTER_VALUE': '{{distance, number}} {{units}}',

    'Избранные свободные инвестиционные площадки': 'Favorite free investment sites',
    'Избранные индустриальные парки': 'Favorite industrial parks',
    'Избранные проекты': 'Favorite investment projects',
    'Избранные объекты программ развития': 'Favorite objects of development programs',

    'Презентации': 'Presentations',

    // -- мобильная версия
    'Список слоёв': 'Layers List',
    'Базовая карта': 'Basemap',

    // -- фиксированные маштабы
    'Мир': 'World',
    'Страна': 'Country',
    'Регион': 'Region',
    'Площадки': 'Sites',
    'Проекты': 'Projects',
    'Планы': 'Plans',
    'Потенциал': 'Potential',

    // -- инструменты
    'Координата': 'Location',
    'Расстояние': 'Distance',
    'Площадь': 'Area',
    'Радиус': 'Radius',
    // 'Печать': 'Print',
    // 'Скачать изображение': 'Download image',
    'Ссылка': 'Link',

    // -- скачать изображение
    'Оригинал': 'Original',
    'Заголовок': 'Header',
    // 'Легенда': 'Legend',
    'Скачать в PNG': 'Download as PNG',
    'Скачать в JPEG': 'Download as JPEG',

    // -- сообщить об ошибке
    'Сообщить об ошибке': 'Send a report',
    'Отправить': 'Send',

    // -- кнопки
    'OK': 'OK',
    'Отмена': 'Cancel',
    'нет': 'no',
    'Повторить': 'Retry',

    // -- поиск
    // 'Объекты': 'Objects',
    // 'Адрес': 'Address',
    'ПКК': 'PCM',
    // 'Нет результатов для данного запроса': 'No results for this search query',
    // для omjs виджета поиска
    // 'По вашему запросу ничего не найдено': 'No results for this search query',
    // 'Произошла ошибка на стороне сервера': 'Server error',
    // 'Слой карты': 'Map layer',

    // -- расстояние
    'км': 'km',
    'м': 'm',

    // -- масштабная линейка
    ' км': ' km',
    ' м': ' m',
    ' мм': ' mm',
    ' миль': ' mi',
    ' фут': ' ft',
    ' дюйм': ' in',

    // -- панель
    'Фильтровать': 'Filter',
    'Сбросить фильтр': 'Reset filter',
    'Список': 'List',
    'По умолчанию': 'By default',

    'Общая информация': 'Overview',
    'Свободные площади для резидентов ТОСЭР': 'Free space for TASED residents',

    // -- список объектов
    'Выгрузить в Excel': 'Download to Excel',

    // -- информационное окно
    'Назад': 'Back',
    'Описание': 'Description',
    'Медиа': 'Media',
    'Документы': 'Documents',
    'Слои': 'Layers',
    'Прозрачность': 'Transparency',
    'Добавить в избранное': 'Add to favorites',
    'Удалить из избранного': 'Remove from favorites',
    'Приблизить': 'Zoom To',
    'Скачать PDF': 'Download PDF',
    'Отобразить возможность подключения на карте': 'Show ability to connect on map',
    'Скачать Excel': 'Download Excel',

    // -- фильтры
    'Перейти к списку': 'To the list',
    'Выбрано объектов:': 'Selected objects:',

    // -- ссылка
    'Ссылка скопирована в буфер обмена': 'Link copied to clipboard',
    'Ссылка на карту': 'Map link',
    'Ссылка на объект': 'Object link',

    // --Сортировка
    'Название': 'Name',

    'Не выбрано': 'Not selected',

    // -- фильтры
    'Фильтры': 'Filters',
    'от': 'from',
    'до': 'to',
    'млн руб.': 'mln rub.',
    'млн.': 'mln.',
    'млрд.': 'bln.',
    'га': 'ha',
    'руб': 'rub.',
    'МВт': 'MW',
    'чел.': 'people',
    'Выбрано': 'Selected',
    'тыс.м3/час': 'thousand m3/hour',

    // -- кадастровая карта
    'Номер': 'Number',
    'Районов': 'Regions',
    'Кварталов': 'Quarters',
    'Участков': 'Plots',
    'Дата': 'Date',
    'Кадастровая карта': 'Cadastral map',
    'Информация по объекту': 'Object info',
    'Кадастровый номер': 'Cadastral number',
    'Наименование': 'Name',
    'Нет данных': 'No data',

    'Эта функция недоступна при использовании карт Яндекс или Спутниковых снимков в качестве подложки': 'This feature is not available when using Yandex maps or Satellite images as a background',

    // -- обратная связь
    'Имя': 'Name',
    'Электронная почта': 'E-mail',
    'Сообщение': 'Message',
    'Прикрепить файл': 'Attach a file',
    'Введите код': 'Enter code',
    'Изменить': 'Edit',
    'Код проверки': 'Captcha code',
    'Размер загружаемого файла превышает 2 МБ': 'File size exceeds 2 MB',
    'Обратная связь': 'Feedback',
    'Сообщение отправлено': 'Message sent',
    'Следующие поля заполнены неверно': 'The following fields are incorrect',

    // -- заявка на подбор площадки
    'ФИО': 'Full name',
    'Телефон': 'Phone',
    'Заявка на подбор инвестиционной площадки': 'Application for selection of an investment site',
    'Заявка на подбор площадки': 'Application for selection of a site',
    'Описание проекта': 'Project description',
    'Требования к площадке': 'Site requirements',

    'Перейти к проекту': 'Open Project',
    'О регионе': 'About the Region',
    'Избранное': 'Favorites',
    'Помощь': 'Help',
    'Подписаться': 'Subscribe',
    'Войти': 'Enter',
    'Выйти': 'Log out',
    'Ошибка авторизации': 'Authorization error',
    'Код ошибки': 'error code',
    'Логин': 'Login',
    'Пароль': 'Password',
    'введите ваш email': 'enter your e-mail',
    'Вы подписались на изменения': 'You are subscribed to changes',
    'Вы уже подписаны  на этот объект': 'You have already Subscribed',
    'Введен некорректный e-mail': 'Incorrect e-mail is entered',

    'О проекте': 'About the project',
    'Программы развития': 'Development programs',
    'Льготы': 'Incentives',
    'Преимущества Ленинградской области': 'Advantages of Leningrad region',
    'По вашему запросу ничего не найдено': 'No results for this search query',
    'Превышено количество объектов для выгрузки.Максимальное количество - 500 объектов.Для уменьшения количества объектов можете воспользоваться фильтром.': 'The number of objects for unloading is exceeded. Maximum number: 500 objects. You can use the filter in order to reduce the number of objects.',
    'Поле обязательно для заполнения': 'Required field',
    'Гринфилд': 'Greenfield',
    'Браунфилд': 'Brownfield',
    'Предложение для девелоперов': 'Offers for developers',
    'Туристско-рекреационные': 'Tourist and recreational',
    'Туристско-рекреационная': 'Tourist and recreational',
    'Скачать приложение': 'Download the application',
    'Авторизация': 'Authorization',
    'Инвестиционное развитие территории Ленинградской области': 'Institute of Regional Innovation Systems',
    'Инвестиционный портал Ленинградской области': 'INVESTMENT PORTAL OF LENINGRAD REGION',
    'Региональная информационная система': 'Regional information system',
    'Скачать': 'Download',
    'Ошибка загрузки': 'Loading error',
    'Сравнение площадок': 'Comparison of sites',
    // 'Функциональные возможности системы': '',
    'Ошибка': 'Error',
    'Выход': 'Log out',

    // -- фильтр подбора площадки
    'подбор площадки': 'site selection',
    'Cбросить фильтр': 'Clear filter',
    'Далее': 'Next',
    'Показать список': 'Show list',
    'показать список': 'show list',
    'Скачать xls': 'Download xls',
    'показать на карте': 'show on map',
    'Показать на карте': 'Show on map',
    'Основное': 'General',
    'Наличие инфраструктуры': 'Infrastructure',
    'Местоположение': 'Location',
    'Дополнительно': 'Additionally',
    'Собственник': 'Owner',
    'Контактное лицо': 'Contact person',
    'свободные инвестиционные площадки': 'free investment sites',
    'Закрыть': 'Close',
    'Изменить тип списка': 'Change list type',
    'Очистить фильтр': 'Clear filter',
    'Предыдущая вкладка': 'Previous tab',
    'Следующая вкладка': 'Next tab',
    'Открыть список отфильтрованных объектов': 'Open list of filtered objects',
    'Скачать отфильтрованные объекты в формате excel': 'Download filtered objects in excel format',
    'Приблизиться к отфильтрованным объектам': 'Zoom to filtered objects',
    'Подбор индустриального парка': 'Industrial park selection',
    'Подбор свободной инвестиционной площадки': 'Free investment site selection',
    'Обучающее видео': 'Video tutorial',
    'тип площадки': 'site type',
    'Инфраструктура': 'Infrastructure',
    'Справка': 'Help',
    'Земельные участки в аренду': 'Land for rent',
    'Пожалуйста, поверните ваше устройство горизонтально': 'Please rotate your device horizontally',
    'Подобрать свободную площадку': 'Find a free site',
    'Навигатор мер поддержки': 'Support measure navigator',
    'Объекты связи': 'Communication facilities',
    'Субсидии в АПК': 'Agro-industry subsidies',
    'Финансовая поддержка МСП': 'SME (Small and medium enterprise) financial support',
    'В 2017 году осуществлена интеграция сведений об инвестиционных объектах из Интегрированной региональной информационной системы(далее – ИРИС) c геоинформационной системой «Фонд пространственных данных Ленинградской области».': 'In 2017, information on capital projects from the Integrated Regional Information System (hereinafter IRIS) was integrated with the Spatial Data Fund of the Leningrad Region geographic information system.',
    'Развернуть': 'Maximize',
    'Свернуть': 'Minimize',
    'В 2019 году для подбора инвестором свободных инвестиционных площадок разработан пошаговый фильтр.В магазинах приложений AppStore и Google Play опубликованы приложения адаптивной версии Карты ИРИС для смартфонов.': 'In 2019, a step-by-step filter was developed for the selection of free investment sites by the investor. Applications of the adaptive version of IRIS Map for smartphones have been published in the AppStore and Google Play application stores.',
    'референт заместителя Председателя Правительства Ленинградской области': 'referent of the deputy prime minister of the Leningrad region',
    'Разместить производство': 'Place production',
    'Подбор свободной площадки для инвестирования': 'Selection of a free site for investment',
    'Инвестиционный потенциал территории': 'Territory\'s investment potential',
    'Перспективы развития территории': 'Prospects for territory development',
    'Общие сведения о территории': 'General information about territory',
    'Сравнить': 'Compare',
    'Объекты для сравнения отсутствуют': 'No objects for comparison',
    'Вернуться на сайт': 'Back to the website',
    'Скачать список': 'Download the list',
    'Оглавление': 'Table of contents',
    'Заявка на производство': 'Application for production',
    'Получить консультацию': 'To get a consultation',
    'Вход': 'Login',
    'Введите слово': 'Enter the word',
    'Подать заявку': 'File an application',
    'Организация': 'Organization',
    'Площадь земельного участка': 'Land plot area',
    'Введите слово с картинки': 'Enter the word from the picture',
    'Поиск': 'Search',
    'Объекты': 'Objects',
    'Адрес': 'Address',
    'Найдено площадок': 'Found sites',
    'Сбросить': 'Reset',
    'Тип площадки': 'Site type',
    'Возможность подключения к центрам питания': 'Ability to connect to main substations',
    'Возможность подключения к газоснабжению': 'Possibility of connection to gas supply',
    'Заявка на обновление данных': 'Request for data update',
    'Выберите слой для выгрузки': 'Select the layer to download',
    'Выгрузить': 'Download',
    'Пространственный раздел стратегии': 'Spatial strategy section',
    'Существующие промышленные предприятия': 'Existing industrial enterprises',
    'Экономическая специализация': 'Economic specialization',
    'Социально - экономическое зонирование': 'Social and economic zoning',
    'Существующая специализация': 'Existing specialization',
    'Перспективная специализация': 'Prospective specialization',
    'Зона контролируемой агломерации': 'Controlled agglomeration zone',
    'Подцентры агломерации': 'Subcenters of agglomeration',
    'Другие территории агломерации': 'Other territories of agglomeration',
    'Точки роста': 'Point of growth',
    'Малые агломерации': 'Small agglomerations',
    'Зоны равновесия': 'Balance zones',
    'Отдаленные территории': 'Remote territories',
    'Исторические поселения': 'Historical settlements',
    'Демографическая ситуация и прогноз': 'Demographic situation and forecast',
    'Динамика численности населения': 'Dynamics of population',
    'Доля численности населения': 'Population share',
    'Численность постоянного населения, тыс.чел.': 'Resident population, thousands of people',
    'Доля численности МО в общей численности Ленинградской области, %': 'Share of the MR (Moscow Region) population in the total population of the Leningrad Region, %',
    'Прогнозная численность постоянного населения, тыс.чел.': 'Projected number of resident population, thousands of people',
    'Балансовая принадлежность': 'Balance sheet attribution',
    'Максимально используемая мощность по результатам замеров почасовых объемов потребления, МВт': 'Maximum power utilization based on hourly consumption measurements, MW',
    '"Текущий резерв/ дефицит мощности,': '"Current power reserve/shortage,',
    '"Текущий резерв/дефицит мощности для технологического присоединения,': '"Current power reserve/shortage for technological connection,',
    'Ссылка на "личный кабинет" территориальной сетевой организации': 'Link to the "personal area" of the territorial network organization',
    'Расчет стоимости технологического присоединения': 'Calculation of the cost of technological connection',
    'Класс предприятия в соответствии с разделом VII.2 Приказа Минэкономразвития России от 09.01.2018 № 10': 'Class of enterprise in accordance with Section VII.2 of the Order of the Ministry of Economic Development of Russia dated 09.01.2018 No. 10',
    'Вид экономической деятельности по ОКВЭД': 'Type of economic activity as per OKVED (Russian Standard Industrial Classification of Economic Activities)',
    'Среднесписочная численность сотрудников, чел.': 'Average number of employees, people',
    'no-internet': 'Check your internet connection and try again',
    'Повтор': 'Retry',
    //
    'Email указан неверно': 'Email is incorrect',
    'Для управления слоями приблизьтесь к территории': 'To manage layers, get closer to the territory',

    'Скрыть объекты': 'Hidden objects',

    // Заголовки страниц
    'root': 'Investment sites, parks and infrastructure on the map of the Leningrad Region',
    'select': 'Selection of a free site for investment on the map of the Leningrad Region',
    'potential': 'Territory\'s investment potentialon the map of the Leningrad Region',
    'info': 'General information about territory on the map of the Leningrad Region',
    'prospects': 'Prospects for territory development and strategy on the map of the Leningrad Region',

    // Баннер
    'Санкт-Петербург, Малоохтинский проспект, дом 64, литера Б, офис 402': 'St. Petersburg, Malokhtinsky prospect, 64/B, office 402',
    'Имущество для МСП': 'Property for SME',
    'Имущество для бизнеса': 'Property for business',
    'Аренда и продажа з/у. Торги': 'Rent and sale of land plots Bargaining',
    'Тарифы': 'Tariffs',
    'На сайт': 'To the website',
    'Список пуст': 'List is empty',
    'Администрирование': 'Administration'
});
